module.exports = __webpack_public_path__ + "static/img/20.f4e0acf0.png";